import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import Login from './components/Login';
import Admin from './pages/Admin';
import Upload from './pages/Upload';
import Query from './pages/Query';
import Analytics from './pages/Analytics';
import Users from './pages/Users';
import Docs from './pages/Docs';
import Predict from './pages/Predict';
import Benchmark from './pages/Benchmark';
import Campaigns from './pages/Campaigns';
import AdminUsers from './pages/AdminUsers';
import './App.css';

function getToken() { try { return localStorage.getItem('token'); } catch(e) { return null; } }
function clearAuth() { try { localStorage.clear(); } catch(e) {} delete axios.defaults.headers.common['Authorization']; }

function NavBar({ user, onLogout }) {
  const location = useLocation();
  const isActive = (path) => location.pathname === path ? 'nav-link active' : 'nav-link';
  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/campaigns" className="nav-logo-link">
          <span className="nav-logo-icon">&#9670;</span>
          <span className="nav-logo-text">SpineBase</span>
        </Link>
        <ul className="nav-menu">
          <li><Link to="/campaigns" className={isActive('/campaigns')}>Campaigns</Link></li>
          {user.role === 'admin' && <li><Link to="/admin" className={isActive('/admin')}>Dashboard</Link></li>}
              {user.role === 'admin' && <li><Link to="/users" className={isActive('/users')}>Users</Link></li>}
          <li><Link to="/upload" className={isActive('/upload')}>Upload</Link></li>
          <li><Link to="/benchmark" className={isActive('/benchmark')}>My Practice</Link></li>
              <li><Link to="/predict" className={isActive('/predict')}>Predict</Link></li>
              <li><Link to="/query" className={isActive('/query')}>Query</Link></li>
              <li><Link to="/docs" className={isActive('/docs')}>Docs</Link></li>
              <li><Link to="/analytics" className={isActive('/analytics')}>Analytics</Link></li>
          <li className="nav-user">{user.name}</li>
          <li><button onClick={onLogout} className="nav-link logout-btn">Logout</button></li>
        </ul>
      </div>
    </nav>
  );
}

function App() {
  const [user, setUser] = useState(null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const token = getToken();
    if (token && token.startsWith('ey')) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
      axios.get('/api/auth/me', { timeout: 5000 })
        .then(res => { if (res.data && res.data.user) setUser(res.data.user); else clearAuth(); })
        .catch(() => clearAuth())
        .finally(() => setChecked(true));
    } else {
      clearAuth();
      setChecked(true);
    }
  }, []);

  const handleLogin = (userData) => { setUser(userData); setChecked(true); };
  const handleLogout = () => { setUser(null); clearAuth(); };

  if (!checked) return null;
  if (!user) return <Login onLogin={handleLogin} />;

  return (
    <Router>
      <div className="App">
        <NavBar user={user} onLogout={handleLogout} />
        <div className="content">
          <Routes>
            <Route path="/" element={<Navigate to="/campaigns" />} />
            <Route path="/campaigns" element={<Campaigns user={user} />} />
            <Route path="/admin" element={user.role === 'admin' ? <Admin /> : <Navigate to="/campaigns" />} />
            <Route path="/upload" element={<Upload />} />
            <Route path="/query" element={<Query />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/users" element={<Users />} />
            <Route path="/admin/users" element={<AdminUsers />} />
            <Route path="/benchmark" element={<Benchmark />} />
            <Route path="/predict" element={<Predict />} />
            <Route path="/docs" element={<Docs />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}
export default App;
